module.exports = __webpack_public_path__ + "static/media/MBTC-logo.58afb5bf.png";